import PropTypes from "prop-types";

import { getCleanLabel, roundOff } from "utils";
import { CardKeyStatsContainer } from "./KeyStats.styles";

const KeyStats = ({ stats, onClick }) => {
  return (
    <CardKeyStatsContainer onClick={onClick}>
      {!stats?.length && <p className="no-data">No Key Statistics found</p>}

      {stats?.length > 0 && (
        <div className="key-stats-wrapper">
          <ul>
            {stats.map((stat, ind) => {
              const label = getCleanLabel(stat.name);
              let value = stat.value;
              if (stat.value && typeof stat.value !== "string") {
                value = roundOff(stat.value);
              }
              return (
                <li key={ind}>
                  <div className="key text-ellipsis" title={value}>
                    {value}
                    <span className="stats text-ellipsis" title={label}>
                      {label}
                    </span>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </CardKeyStatsContainer>
  );
};

export default KeyStats;

KeyStats.propTypes = {
  stats: PropTypes.array,
  showTitle: PropTypes.bool,
  onClick: PropTypes.func,
};

KeyStats.defaultProps = {
  stats: {},
  showTitle: true,
};
